import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    errorMessage:'',
    status:'initial',
    leads:{},
};
const LeadsReducer = createSlice({
    name: 'Leads',
    initialState,
    reducers:{
        setResetLeads: (state)=>{
            state.errorMessage = '';
            state.status = 'initial';
            state.leads = {};
        },
        setLoadingLeads: (state)=>{
            state.errorMessage = '';
            state.status = 'loading';
        },
        setSuccessLeads: (state,action)=>{
            state.errorMessage = '';
            state.status = 'success';
            state.leads=action.payload
        },
        setErrorLeads: (state,action)=>{
            state.errorMessage = action.payload;
            state.status = 'error';
        },
    },
});

export default LeadsReducer.reducer;
export const {setResetLeads,setErrorLeads,setLoadingLeads,setSuccessLeads} = LeadsReducer.actions;
